import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import CottagesComponent from "../components/cottages"
import CabinsFullWidth from "../components/cabinsFullWidth"
import ContactInfo from "../components/contactInfo"

const Cottages = () => {  

  return (
    <Layout>
      <SEO
        title="Cottages"
        description="Vacation cabins and cottages at Gold Coast Retreat, a one-minute walk from Chesterman Beach in Tofino, BC."
      />
      <CabinsFullWidth/>
      <CottagesComponent  heading="Cottages" subHeading="For The Perfect Tofino Vacation"/>
      <ContactInfo />
    </Layout>
  )
}

export default Cottages